import { type ReactElement } from 'react';
import { X, Save } from 'lucide-react';
import { Button } from '@/components/atoms/button';

export type FormSummaryBandProps = {
  summary: string;
  submitLabel: string;
  onCancel: () => void;
  onSubmit: () => void;
  canSubmit: boolean;
  isSubmitting: boolean;
};

export function FormSummaryBand({
  summary,
  submitLabel,
  onCancel,
  onSubmit,
  canSubmit,
  isSubmitting,
}: FormSummaryBandProps): ReactElement {
  const submitDisabled = !canSubmit || isSubmitting;
  const resolvedSubmitLabel = isSubmitting ? 'Saving…' : submitLabel;

  return (
    <div className="sticky bottom-0 flex flex-col gap-2 border-t border-[var(--rule)] bg-[var(--bg-surface)] pt-4 pb-4">
      <p className="truncate text-sm text-[var(--ink-2)]">{summary}</p>
      <div className="flex items-center justify-end gap-3">
        <Button type="button" variant="secondary" onClick={onCancel} disabled={isSubmitting}>
          <X className="h-4 w-4" /> Cancel
        </Button>
        <Button
          type="button"
          variant="brand"
          onClick={onSubmit}
          disabled={submitDisabled}
        >
          <Save className="h-4 w-4" /> {resolvedSubmitLabel}
        </Button>
      </div>
    </div>
  );
}
